import React, { useEffect, useRef, useState } from "react";

const ParagraphTitle: React.FC<{ title: string; color: string }> = ({
  title,
  color,
}) => {
  const sectionRef = useRef<HTMLElement>(null);
  const leftLineRef = useRef<HTMLSpanElement>(null);
  const titleRef = useRef<HTMLElement>(null);
  const rightLineRef = useRef<HTMLSpanElement>(null);
  const [leftLineVisible, setLeftLineVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [rightLineVisible, setRightLineVisible] = useState(false);

  useEffect(() => {
    if (sectionRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // Trigger child animations with delays
            setTimeout(() => setLeftLineVisible(true), 0);
            setTimeout(() => setTitleVisible(true), 150);
            setTimeout(() => setRightLineVisible(true), 300);
            observer.unobserve(sectionRef.current!);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(sectionRef.current);
      return () => observer.disconnect();
    }
  }, []);

  return (
    <>
      <section ref={sectionRef} className="lg:py-[100px] py-[60px]">
        <div className="w-full px-5 flex items-center lg:justify-between justify-center gap-x-14">
          <span
            ref={leftLineRef}
            className={`flex-1 h-[1px] bg-[#d1d2d3] lg:block hidden fade-in-section ${
              leftLineVisible ? "fade-in-visible" : ""
            }`}
          ></span>
          <b
            ref={titleRef}
            className={`text-5xl text-[40px] flex-shrink-0 fade-in-section ${
              titleVisible ? "fade-in-visible" : ""
            }`}
            style={{ color: color }}
          >
            {title}
          </b>
          <span
            ref={rightLineRef}
            className={`flex-1 h-[1px] bg-[#d1d2d3] lg:block hidden fade-in-section ${
              rightLineVisible ? "fade-in-visible" : ""
            }`}
          ></span>
        </div>
      </section>
    </>
  );
};

export default ParagraphTitle;
